<template>
  <b-modal
    ref="shareDashboardModal"
    hide-footer
    centered
    title="Share dashboard with..."
    >
    <b-form @submit.prevent="shareDashboard" novalidate>
      <b-form-group
        label="E-mail addresses:"
        >
        <div role="group">
          <input-tag
            :tags.sync="emails"
            placeholder="Type E-mail addresses here..."
            :read-only="inProgress"
            class="form-control"
            validate="email"
            />
        </div>
      </b-form-group>
      <b-form-group
        label="Deligate access to:"
        v-if="emails.length"
        >
        <b-form-checkbox
          v-model="rules.update"
          >
          update
        </b-form-checkbox>
      </b-form-group>
      <b-form-group
        label="Is public:"
        >
        <b-form-checkbox v-model="asPublic">
          <span v-if="asPublic">Yes</span>
          <span v-else>No</span>
        </b-form-checkbox>
      </b-form-group>
      <b-button type="submit" :disabled="inProgress">Save</b-button>
    </b-form>
  </b-modal>
</template>

<script>
// services
import user from '@/services/user'
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

let $ = window.$

export default {
  data () {
    return {
      emails: [],
      rules: {
        update: false
      },
      asPublic: false,
      inProgress: false,
      currentDash: null
    }
  },
  methods: {
    shareDashboard () {
      if (this.inProgress) return

      this.inProgress = true

      this.$store.commit('addProcess', {
        process: 'shareDashboard',
        message: 'Sharing'
      })

      db.dashboards.makePublic(this.currentDash, this.asPublic, () => {
        if (!this.emails.length) {
          this.$refs.shareDashboardModal.hide()
          this.$store.commit('deleteProcess', 'shareDashboard')
          this.inProgress = false
        }
      })

      if (!this.emails.length) return

      let shareOps = []

      for (let email of this.emails) {
        user.getUserByEmail(email).then((data) => {
          if (data.uid) {
            let payload = {
              uid: data.uid,
              dash: this.currentDash,
              rules: this.rules
            }

            db.dashboards.share(payload, (err) => {
              if (err) this.$store.commit('addError', err.message)
              shareOps.push(email)

              if (shareOps.length === this.emails.length) {
                this.inProgress = false
                this.$refs.shareDashboardModal.hide()
                this.$store.commit('deleteProcess', 'shareDashboard')
                this.emails = []
                this.rules = { update: false }
              }
            })
          } else {
            console.log(data.error)
            shareOps.push(email)

            if (shareOps.length === this.emails.length) {
              this.inProgress = false
              this.$refs.shareDashboardModal.hide()
              this.$store.commit('deleteProcess', 'shareDashboard')
              this.emails = []
              this.rules = { update: false }
            }
          }
        })
      }
    }
  },
  created () {
    this.currentDash = this.$store.state.currentDash
    eventBus.$on('shareDashboard', () => {
      if (this.$refs.shareDashboardModal) this.$refs.shareDashboardModal.show()
    })
    db.dashboards.isPublic(this.currentDash, (isPublic) => {
      this.asPublic = isPublic || false
    })
  },
  mounted () {
    if (this.$refs.shareDashboardModal) {
      $(this.$refs.shareDashboardModal['$el']).appendTo('body')
    }
  },
  beforeDestroy () {
    if (this.$refs.shareDashboardModal) {
      $(this.$refs.shareDashboardModal['$el']).remove()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/ShareDashboard.vue